import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import {
  BackIcon,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
  useTheme
} from "@carrotfertility/carotene-core"
import React, { useState } from "react"
import { FormattedMessage } from "react-intl"

export function CheckboxStep({
  title,
  description,
  primaryCheckBoxLabel,
  secondaryCheckBoxLabel
}: {
  title: string
  description: string
  primaryCheckBoxLabel: string
  secondaryCheckBoxLabel?: React.ReactNode
}): JSX.Element {
  const theme = useTheme()
  const { send, back } = useStateMachine()
  const [isPrimaryConfirmed, setIsPrimaryConfirmed] = useState(false)
  const [isSecondaryConfirmed, setIsSecondaryConfirmed] = useState(false)

  const isAllConfirmed = secondaryCheckBoxLabel ? isPrimaryConfirmed && isSecondaryConfirmed : isPrimaryConfirmed

  function handleContinue(): void {
    send("")
  }

  return (
    <Box>
      <Typography variant="h3" sx={(theme) => ({ marginBlockEnd: theme.tokens.spacing.xs })}>
        {title}
      </Typography>

      <Stack spacing={theme.tokens.spacing.xl}>
        <Typography>{description}</Typography>

        <Stack spacing={theme.tokens.spacing.md}>
          <FormControlLabel
            control={
              <Checkbox checked={isPrimaryConfirmed} onChange={(e) => setIsPrimaryConfirmed(e.target.checked)} />
            }
            label={primaryCheckBoxLabel}
          />
          {secondaryCheckBoxLabel && (
            <FormControlLabel
              control={
                <Checkbox checked={isSecondaryConfirmed} onChange={(e) => setIsSecondaryConfirmed(e.target.checked)} />
              }
              label={secondaryCheckBoxLabel}
            />
          )}
        </Stack>

        <Box
          sx={(theme) => ({
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBlockStart: theme.tokens.spacing.md
          })}
        >
          <Button variant="text" color="secondary" onClick={back} startIcon={<BackIcon />}>
            <FormattedMessage defaultMessage="Back" />
          </Button>

          <Button variant="outlined" color="secondary" onClick={handleContinue} disabled={!isAllConfirmed}>
            <FormattedMessage defaultMessage="Continue" />
          </Button>
        </Box>
      </Stack>
    </Box>
  )
}
